// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DdjDocument, InternalDocumentTypeIds } from '@interfaces/document.interfaces';
import { AppEvent } from '@interfaces/interfaces';
import { DealershipService } from '@services/dealership.service';
import { DocumentsService } from '@services/documents.service';
import { UserService } from '@services/user.service';
import { catchError, takeWhile } from 'rxjs';
@Component({
    selector: 'buyer-view',
    templateUrl: './buyer-view.component.html',
    styleUrls: ['./buyer-view.component.scss'],
})
export class BuyerViewComponent implements OnInit, OnDestroy {
    public dealId: number = null;
    public docId: any = null;
    public document: DdjDocument = null;
    private isComponentAlive = true;
    public isLoading = false;
    public template = 'view';

    constructor(
        private readonly dealershipService: DealershipService,
        private readonly documentsService: DocumentsService,
        private readonly router: Router,
        private route: ActivatedRoute,
        private readonly userService: UserService
    ) {}

    ngOnInit(): void {
        this.route.params.pipe(takeWhile(() => this.isComponentAlive)).subscribe((param) => (this.docId = param.docId));

        if (this.docId) {
            this.document = this.documentsService.getDocById(parseInt(this.docId));
            this.userService.setUserCurrentDealer(this.document.dealerId);
            this.dealId = this.document.dealId;
        } else {
            this.dealId = this.route.snapshot.data.deal.dealId;
            const windowSticker = this.documentsService.getDocByInternalTypeId(InternalDocumentTypeIds.MonroneyLabel);
            this.document = this.documentsService.getDocById(windowSticker.documentId);
            this.userService.setUserCurrentDealer(this.document.dealerId);
        }

        this.dealershipService
            .getDealer$(this.document.dealerId)
            .pipe(
                takeWhile(() => this.isComponentAlive),
                catchError((error) => {
                    this.isLoading = false;
                    console.error('unable to get dealer', error);
                    throw error;
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    public eventHandler(event: AppEvent): void {
        switch (event.context) {
            case 'cancel':
                this.close();
                break;
            default:
                break;
        }
    }

    public close(): void {
        window.location.pathname.includes('info')
            ? this.router.navigate(['main', 'vehicles', this.dealId, 'info'])
            : this.router.navigate(['main', 'vehicles', this.dealId]);
    }
}
